import axios from "axios";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { SO_API } from "../CreateSalesOrder/data";
import { ginesysSyncTone, soStatusTone } from "../CreateSalesOrder/soUi";

export const lsSoFilterValStr = "sales_order_filter_obj";

export const soStatusOptions = Object.keys(soStatusTone).map((key) => ({ key, name: key }));
export const ginesysSyncOptions = Object.keys(ginesysSyncTone).map((key) => ({ key, name: key }));

export const boolFilterOptions = [
	{ key: true, name: "Yes" },
	{ key: false, name: "No" },
];

const enterColumn = (name, key, dataType = datatypes.STRING.key) => ({
	name,
	key,
	input_type: inputTypes.ENTER.key,
	data_type: dataType,
	editable: true,
	constraints: { DISPLAY: true },
});

const selectColumn = (name, key, list) => ({
	name,
	key,
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	editable: true,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: { type: arrType, list },
});

export const soListColumnsObj = {
	id: enterColumn("ID", "id", datatypes.NUMBER.key),
	so_number: enterColumn("SO Number", "so_number"),
	order_no: enterColumn("Order No", "order_no"),
	status: selectColumn("Status", "status", soStatusOptions),
	owner_site_code: enterColumn("Owner Site", "owner_site_code", datatypes.NUMBER.key),
	destination_site_code: enterColumn("Destination Site", "destination_site_code", datatypes.NUMBER.key),
	order_date: enterColumn("Order Date", "order_date", datatypes.DATE.key),
	intg_order_id: enterColumn("Intg Order Id", "intg_order_id"),
	ginesys_sync: selectColumn("Ginesys Sync", "ginesys_sync", ginesysSyncOptions),
	is_authorized: selectColumn("Authorized", "is_authorized", boolFilterOptions),
	created_by: enterColumn("Created By", "created_by"),
	published_by: enterColumn("Published By", "published_by"),
};

export const soListTableColumns = [
	soListColumnsObj.id,
	soListColumnsObj.order_no,
	soListColumnsObj.status,
	soListColumnsObj.owner_site_code,
	soListColumnsObj.destination_site_code,
	soListColumnsObj.order_date,
	soListColumnsObj.intg_order_id,
	soListColumnsObj.ginesys_sync,
	soListColumnsObj.is_authorized,
	soListColumnsObj.created_by,
].map((col) => ({
	...col,
	align: "center",
	headerAlign: "center",
	minWidth: col.key === "order_no" || col.key === "intg_order_id" ? 140 : 110,
}));

export const getSoFilterColumns = () => [
	soListColumnsObj.order_no,
	soListColumnsObj.so_number,
	soListColumnsObj.status,
	soListColumnsObj.owner_site_code,
	soListColumnsObj.destination_site_code,
	soListColumnsObj.intg_order_id,
	soListColumnsObj.ginesys_sync,
	soListColumnsObj.is_authorized,
	soListColumnsObj.created_by,
	soListColumnsObj.published_by,
];

export const listSalesOrdersApi = async ({ limit, offset, filter }) => {
	const res = await axios.post(`${SO_API}/list`, { limit, offset, filter });
	return res.data?.result || { rows: [], total_rows_count: 0 };
};
